/** Unified UX paths — marketing + commerce share hamssah.com after merge. */

export const HOME_DIAGNOSTIC_PATH = '/diagnostic';
export const HOME_DIAGNOSTIC_PHOTO_PATH = '/diagnostic/photo';
export const HOME_DIAGNOSTIC_QUIZ_PATH = '/flows/regimenbuilder';
export const HOME_CONCEPT_PATH = '/concept';

export const SHOP_NOUVEAUTES_QUERY = { sortBy: 'createdAt', sortOrder: 'desc' } as const;

export const PLP_PRICE_BUCKETS = [
  { id: '0-200', label: 'Moins de 200 MAD', min: 0, max: 200 },
  { id: '200-400', label: '200 – 400 MAD', min: 200, max: 400 },
  { id: '400+', label: 'Plus de 400 MAD', min: 400, max: null },
] as const;

export const SKIN_PROFILE_STORAGE_KEY = 'hamssah_skin_profile';
/** Camera consent for diagnostic photo / skin-scan widget (localStorage). */
export const SKIN_SCAN_CAMERA_CONSENT_KEY = 'hamssah_skin_scan_camera_consent';
export const RECENTLY_VIEWED_STORAGE_KEY = 'hamssah_recently_viewed';
export const SAVED_LATER_STORAGE_KEY = 'hamssah_saved_later';
export const LOYALTY_STORAGE_KEY = 'hamssah_loyalty';

export type StoredSkinProfile = {
  method: 'quiz' | 'photo';
  name: string;
  desc: string;
  productIds: string[];
  updatedAt: string;
  /** Live photo scan scores / match query for revisit. */
  scores?: Record<string, number>;
  matchQuery?: {
    skinType: string;
    concern: string;
    texture: string;
    pace: string;
    tags: string[];
  };
  inferredConcern?: string;
};

export type RecentlyViewedItem = {
  id: string;
  slug: string;
  name: string;
  thumbnail?: string | null;
  price?: number | null;
};

export type LoyaltySnapshot = {
  points: number;
  referralCode: string;
};

export function concernTag(value: string): string {
  const v = value ?? '';
  return v.startsWith('concern:') ? v : `concern:${v}`;
}
